import { arrayUnion, doc, getDoc, updateDoc } from 'firebase/firestore';
import { firestore } from 'services/firebase/client';
import type { SubscriptionPaymentDetails } from 'utils/subscriptionPayment';
import { ISubscription } from 'utils/types/Subscription';

/**
 * Atualiza o campo `subscription` do documento do usuário na coleção `subscription_users`.
 */
export async function updateUserSubscription(
  userId: string,
  subscription: ISubscription,
) {
  try {
    const userRef = doc(firestore, 'subscription_users', userId);
    await updateDoc(userRef, {
      subscriptions: arrayUnion(subscription),
      funnelStatus: 'shipping',
      updatedAt: new Date().toISOString(),
    });
  } catch (error) {
    console.error('Erro ao atualizar a subscription:', error);
    throw error;
  }
}

/**
 * Ativa assinatura após pagamento (cartão ou PIX).
 */
export async function updateSubscriptionById(
  userId: string,
  subscriptionId: string,
  preapprovalId: string,
  planId?: string,
  paymentDetails?: SubscriptionPaymentDetails,
) {
  try {
    const userRef = doc(firestore, 'subscription_users', userId);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      throw new Error('Usuário não encontrado.');
    }

    const userData = userSnap.data();
    const subscriptions = userData.subscriptions || [];

    const updatedSubscriptions = subscriptions.map((sub: ISubscription) =>
      sub.id === subscriptionId
        ? {
            ...sub,
            preapprovalId,
            status: 'Ativa',
            ...(planId && { planId }),
            ...(paymentDetails && {
              paymentMethod: paymentDetails.paymentMethod,
              mercadoPagoPaymentId: paymentDetails.mercadoPagoPaymentId,
              paidAt: paymentDetails.paidAt,
              renewalDueAt: paymentDetails.renewalDueAt,
            }),
          }
        : sub,
    );

    await updateDoc(userRef, {
      subscriptions: updatedSubscriptions,
      funnelStatus: 'paid',
      updatedAt: new Date().toISOString(),
    });
  } catch (error) {
    console.error('Erro ao atualizar a subscription:', error);
    throw error;
  }
}
